/**
 * Minimal polyline6 encoder/decoder (portable, no external deps).
 * Coordinates are [lon, lat] (GeoJSON / Mapbox order).
 */

export function decodePolyline(str, precision = 6) {
  const factor = Math.pow(10, precision)
  let index = 0
  let lat = 0
  let lng = 0
  const coordinates = []

  while (index < str.length) {
    let result = 0
    let shift = 0
    let byte
    do {
      byte = str.charCodeAt(index++) - 63
      result |= (byte & 0x1f) << shift
      shift += 5
    } while (byte >= 0x20)
    const deltaLat = result & 1 ? ~(result >> 1) : result >> 1
    lat += deltaLat

    result = 0
    shift = 0
    do {
      byte = str.charCodeAt(index++) - 63
      result |= (byte & 0x1f) << shift
      shift += 5
    } while (byte >= 0x20)
    const deltaLng = result & 1 ? ~(result >> 1) : result >> 1
    lng += deltaLng

    coordinates.push([lng / factor, lat / factor])
  }

  return coordinates
}

/**
 * Decode Valhalla/Mapbox shape: polyline string or [lon,lat][] array.
 * @returns {number[][]} [lon, lat][]
 */
export function decodeShape(shape, precision = 6) {
  if (
    Array.isArray(shape) &&
    shape.length > 0 &&
    Array.isArray(shape[0]) &&
    typeof shape[0][0] === 'number'
  ) {
    // Heuristic: Valhalla utils/polyline decode returns [lat,lng]; Mapbox is [lon,lat].
    // If |coord0| <= 90 and |coord1| > 90, treat as [lat,lng] and swap.
    const first = shape[0]
    if (Math.abs(first[0]) <= 90 && Math.abs(first[1]) > 90) {
      return shape.map(([lat, lon]) => [lon, lat])
    }
    return shape.map(([lon, lat]) => [lon, lat])
  }
  if (typeof shape === 'string' && shape.length > 0) {
    return decodePolyline(shape, precision)
  }
  return []
}
